import { defineElement, TemplateElement } from '@webtides/element-js';

import styles from './_dropdown-sort.css';
import template from './dropdown-sort.template';
import BaseDropDownSort from '@zeg/base-light-module/frontend/components/structures/_category-page/dropdown-sort/dropdown-sort.class';

class DropdownSort extends BaseDropDownSort {
    constructor() {
        super({ styles: [styles] });
    }

    template() {
        return template(this);
    }
}

defineElement('dropdown-sort', DropdownSort);
